/* eslint-disable camelcase */
import nba from './nba';
import nhl from './nhl';
import nfl from './nfl';
import ncaafb from './ncaafb';
import ncaamb from './ncaamb';
import ncaawb from './ncaawb';
import mlb from './mlb';
import mls from './mls';
import nwsl from './nwsl';
import epl from './epl';
import fifa_world_cup from './fifa_world_cup';
import nascar_cup from './nascar_cup';
import nascar_truck from './nascar_truck';
import nascar_oaps from './nascar_oaps';

export default {
  nba,
  nhl,
  nfl,
  ncaafb,
  ncaamb,
  ncaawb,
  mlb,
  mls,
  nwsl,
  epl,
  fifa_world_cup,
  nascar_cup,
  nascar_truck,
  nascar_oaps,
};
